(function($) {
	$('.js-toggle').on('click', function(){
		var target = $(this).data('target');
		var activeClass = target+'--active';
		$('#'+target).toggleClass(activeClass);
		$('body').toggleClass('body--'+target.replace('__', '-')+'-active')
	});
})( jQuery );